import { AllowObservableContextBaseConstruct } from '../../../../core/observable/context/base/constructor';
import { NotificationsObservableContext } from '../../../core/notifications-observable/context/implementation';
import { Notification } from '../../../core/notification/implementation';
import { FiniteStateObservableClearCache, FiniteStateObservableOnEmit } from '../functions';
export function NewFiniteStateObservableContext(observable) {
    AllowObservableContextBaseConstruct(true);
    const context = new FiniteStateObservableContext(observable);
    AllowObservableContextBaseConstruct(false);
    return context;
}
export class FiniteStateObservableContext extends NotificationsObservableContext {
    constructor(observable) {
        super(observable);
    }
    get observable() {
        return super.observable;
    }
    emit(value) {
        FiniteStateObservableOnEmit(this.observable, value);
        super.emit(value);
    }
    dispatch(name, value) {
        this.emit(new Notification(name, value));
    }
    next(value) {
        this.dispatch('next', value);
    }
    complete() {
        this.dispatch('complete', void 0);
    }
    error(error) {
        this.dispatch('error', error);
    }
    clearCache() {
        FiniteStateObservableClearCache(this.observable);
    }
}
//# sourceMappingURL=implementation.js.map